export default {
      id: "video-event_braking-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#video-event_braking",
      toString: function () {
        return this.url;
      }
    }